<template>
    <teleport to="#modal">
        <Loading :visible="loading">
        </Loading>
        <Modal v-model:visible="modalVisible">
            <template #main>
                <div class="flex flex-col mb-3">
                    <Field field_name="Tipo documento" :errors="errors?.tipo_documento_id">
                        <VueMultiselect :options="tipoDocumentoAutocomplete.options"
                                        v-model="tipoDocumentoAutocomplete.selection"
                                        :loading="tipoDocumentoAutocomplete.isLoading"
                                        @search-change="tipoDocumentoAutocomplete.search"
                                        class="next-vue-multiselect-single overflow-ellipsis mb-3"
                                        :close-on-select="true"
                                        :clear-on-select="false" deselectLabel="Deseleziona" selectedLabel="Selezionato"
                                        selectLabel="Seleziona" track-by="id" label="descrizione"
                                        placeholder="Tipo documento"
                                        titolo="Tipo documento">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="Fornitore" :errors="errors?.fornitore_id">
                        <VueMultiselect :options="fornitoreAutocomplete.options"
                                        v-model="fornitoreAutocomplete.selection"
                                        :loading="fornitoreAutocomplete.isLoading"
                                        @search-change="fornitoreAutocomplete.search"
                                        class="next-vue-multiselect-single overflow-ellipsis mb-3"
                                        :close-on-select="true"
                                        :clear-on-select="false" deselectLabel="Deseleziona" selectedLabel="Selezionato"
                                        selectLabel="Seleziona" track-by="id" label="denominazione"
                                        placeholder="Cerca fornitore"
                                        titolo="Fornitore">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{ option }">
                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                            </template>
                            <template v-slot:option="{ option }">{{
                                    `${option.denominazione} - ${option.ragione_sociale}`
                                }}
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col mb-3">
                    <Field field_name="File" :errors="errors?.file_id">
                        <FileUpload v-model:uploaded_files="uploaded"
                                    accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx">
                            <template v-slot:default="{ props, methods }">
                                <div class="flex justify-center items-center gap-3">
                                    <NextButton variant="outline-secondary" @click="methods.open"
                                                class="w-56 h-10 px-4 grow">
                                        <i class="icon icon-graffetta"></i> Allega
                                    </NextButton>
                                </div>
                                <div v-if="uploaded" class="grid grid-cols-1 gap-3">
                                    <a class="underline text-sm text-next-atp pt-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f, idx) in uploaded" :key="idx">
                                        <span>{{ f.name }}</span>
                                    </a>
                                </div>
                            </template>
                        </FileUpload>
                    </Field>
                </div>

            </template>
            <template #footer>
                <div class="flex justify-end">
                    <NextButton @click="close" variant="outline-secondary" class="w-44 py-1 px-2 mr-2">Chiudi
                    </NextButton>
                    <NextButton @click="saveFile" variant="outline-primary" class="w-44 py-1 px-2">Salva
                    </NextButton>
                </div>
            </template>
        </Modal>
    </teleport>
    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto pt-5">
            <div class="flex justify-between">

                <h2 class="text-3xl font-bold mb-4">Documenti Fornitori</h2>

                <NextButton variant="primary" @click="add" class="ml-4 py-1 px-2">
                    Aggiungi
                </NextButton>
            </div>

            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="cols" :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_0`]="context">
                        <TabellaContextMenu
                            menuClass="shadow absolute flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                            buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                            :context="c" :id="j" teleport_to="#modal" :cmOpener="cmOpener">
                            <span @click="modificaRiga(c)" class="w-full hover:text-next-neu mb-2">Modifica</span>
                            <ConfirmDelete position="right" @cancella="cancellaRiga(c.id)">
                                <span class="cursor-pointer hover:text-next-neu">Elimina</span>
                            </ConfirmDelete>
                        </TabellaContextMenu>
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_3`]="{ context }">
                        <a class="underline text-sm text-next-atp break-words cursor-pointer"
                           @click="downloadFile(c.file_id)">{{ c.file.name }}
                        </a>
                    </template>
                </NextTable>
            </div>
            <InfiniteLoading @infinite="lista.fetchNextPage" :identifier="lista.infiniteIdentifier"
                             style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre righe.</div>
                </template>
            </InfiniteLoading>

        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Lista from "@/setup/ListaCerca";
import Loading from "@/components/Loading.vue";
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import InfiniteLoading from "v3-infinite-loading";
import Modal from "@/components/Modal.vue";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import sottoProgettiManager from "@/api/SottoProgetti";
import Autocomplete from "@/setup/Autocomplete";
import fornitoriManager from "@/api/FornitoriManager";
import documentiFornitoreManager from "@/api/DocumentiFornitoreManager";
import tipiDocumentiFornitoreManager from "@/api/TipiDocumentiFornitoreManager";
import FileUpload from '@/components/FileUpload.vue';
import filesManager from '@/api/File';
import sottoprogettoDocumentiFornitoreManager from '@/api/SottoprogettoDocumentiFornitoreManager';

@Options({
    name: 'DocumentiFornitoriSottoprogetto',
    components: {
        NextTable,
        Paginator,
        Field,
        InfiniteLoading,
        Loading,
        Modal,
        NextButton,
        TabellaContextMenu,
        ConfirmDelete,
        FileUpload
    },
    inject: ['downloadFile'],
    props: {
        id: [Number, String],
    },
    computed: {},
    methods: {}
})
export default class DocumentiFornitoriSottoprogetto extends Vue {
    id!: string;
    loading = false;
    modalVisible = false;
    errors: any = {};
    uploaded: any[] = []
    lista: any = setup(() => Lista(sottoProgettiManager, this.cols, sottoProgettiManager.documentiFornitori));
    cmOpener: any = setup(() => ContextMenuOpener('top-left'))
    fornitoreAutocomplete: any = setup(() => Autocomplete(fornitoriManager, false, {validi: 1}))
    tipoDocumentoAutocomplete: any = setup(() => Autocomplete(tipiDocumentiFornitoreManager, false))
    editing_id: string | number = 0;

    created() {
        this.lista.callBinds = [this.id]
        this.lista.fetchData();

        this.tipoDocumentoAutocomplete.search('', 0)
        this.fornitoreAutocomplete.search('', 0)
    }

    mounted() {
        this.lista.infiniteIdentifier = !this.lista.infiniteIdentifier
    }

    modificaRiga(riga: any) {
        Promise.all([this.fornitoreAutocomplete.retrieve(riga.fornitore_id),
            this.tipoDocumentoAutocomplete.retrieve(riga.tipo_documento_id),
            filesManager.file(riga.file_id).then((res) => {
                this.uploaded = [res.data];
            })]).then(() => {
            this.editing_id = riga.id;
            this.modalVisible = true;
        });
    }

    cancellaRiga(documento_id: string | number) {
        documentiFornitoreManager.cancellaDocumentoFornitore(documento_id).then(() => {
            this.lista.fetchData();
        });
    }

    add() {
        this.editing_id = 0;
        this.modalVisible = true;
    }

    saveFile() {
        this.loading = true;

        if (this.editing_id) {
            this.updateFile();
        } else {
            this.createFile();
        }
    }

    updateFile() {
        const data = {
            fornitore_id: this.fornitoreAutocomplete.selection?.id,
            tipo_documento_id: this.tipoDocumentoAutocomplete.selection?.id,
            file_id: this.uploaded[0]?.id
        }

        sottoprogettoDocumentiFornitoreManager.updateSottoprogettoDocumentiFornitore(this.editing_id, data).then(() => {
            this.postSave();
        }).catch((err: any) => {
            if (err.response.status === 422) {
                this.errors = err.response.data.errors;
            }
            this.loading = false;
        });
    }

    postSave() {
        this.loading = false;
        this.modalVisible = false;
        this.fornitoreAutocomplete.selection = null;
        this.tipoDocumentoAutocomplete.selection = null;
        this.uploaded = [];
        this.lista.fetchData();
    }

    createFile() {

        const data = {
            fornitore_id: this.fornitoreAutocomplete.selection?.id,
            tipo_documento_id: this.tipoDocumentoAutocomplete.selection?.id,
            file_id: this.uploaded[0]?.id
        }

        sottoProgettiManager.creaDocumentoFornitore(this.id, data).then(() => {
            this.postSave();
        }).catch((err) => {
            if (err.response.status === 422) {
                this.errors = err.response.data.errors;
            }
            this.loading = false;
        });
    }

    close() {
        this.modalVisible = false;
    }

    cols = [
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Tipo documento',
            prop: 'tipo_documento.descrizione',
            orderable: true,
            ordProp: 'tipo_documento.descrizione',
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Fornitore',
            prop: 'fornitore.denominazione',
            ordProp: 'fornitore.denominazione',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Nome file',
            prop: 'file.name',
            ordProp: 'file.name',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },

    ]

}

</script>


<style lang="scss" scoped></style>
